import * as stylex from '@stylexjs/stylex';
import { useTranslation } from 'react-i18next';
import { DurationSelector } from '@/core/DurationSelector.atom';
import { colors } from '@seeqdev/qomponents/colors.stylex';
import type { DurationValuesByUnit } from '@/core/DurationSelector.atom';
import type { LiveUpdateRate } from '@/schedule/schedule.types';

interface LiveScheduleProps {
  rate: LiveUpdateRate;
  onChange: (liveUpdateRate: LiveUpdateRate) => void;
  onInvalidInput: (message: string) => void;
  showHelp?: boolean;
  durationValuesByUnit: DurationValuesByUnit;
  disabled?: boolean;
}

export const LiveSchedule = ({
  rate: { unit, value },
  onChange,
  onInvalidInput,
  showHelp = true,
  durationValuesByUnit,
  disabled = false,
}: LiveScheduleProps) => {
  const { t } = useTranslation();

  return (
    <div data-testid="live-schedule-config" {...stylex.props(styles.liveSchedule)}>
      <label>{t('SCHEDULE_TYPE.LIVE.RATE.NAME')}</label>
      {showHelp && <p {...stylex.props(styles.rateHelp)}>{t('SCHEDULE_TYPE.LIVE.RATE.DESCRIPTION')}</p>}
      <DurationSelector
        unit={unit}
        value={value}
        onChange={(value, unit) => onChange({ value, unit })}
        onInvalidInput={onInvalidInput}
        durationValuesByUnit={durationValuesByUnit}
        disabled={disabled}
      />
    </div>
  );
};

const styles = stylex.create({
  liveSchedule: {
    marginBottom: '0.9375rem',
  },
  rateHelp: {
    color: colors.textMuted,
    fontStyle: 'italic',
  },
});
